import { dateToTimestamp, getToday, addMonths } from '@ha/date';

import { FilterBuilder } from '../Types';

const dateFromFilter = (startDate: string) => {
  const startDateTS = dateToTimestamp(new Date(startDate));

  return `dateFromTS<=${startDateTS}`;
};

const dateToFilter = (startDate: string, endDate?: string) => {
  // if end date is specified then use that, otherwise use the startDate
  const endDateTS = dateToTimestamp(new Date(endDate || startDate));

  return `dateToTS>=${endDateTS}`;
};

const dateTSBuilder: FilterBuilder = ({ startDate, endDate }) => {
  // when no dates are specified then return all the inventory that has
  // availability in the next 6 months.
  if (!startDate) {
    const today = getToday();
    const todayPlusSixMonths = addMonths(today, 6);

    return dateFromFilter(todayPlusSixMonths);
  }

  const dateFrom = dateFromFilter(startDate);
  const dateTo = dateToFilter(startDate, endDate);

  return [dateFrom, dateTo].join(' AND ');
};

export default dateTSBuilder;
